import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { applicationConstants } from '../../../../constants/applicationConstants';
import { applicationActions } from '../../../../actions/applicationActions';
import { roleConstants } from '../../../../constants/roleConstants';

class ApplicationDeclineButton extends Component {
  render() {
    const { application, user, handleDecline, cls } = this.props;

    return ((application.status === applicationConstants.STATUS_REVIEW ||
      application.status === applicationConstants.STATUS_REPEAT) &&
      (user.role_id === roleConstants.ROLE_ADMIN || user.role_id === roleConstants.ROLE_OFFICER)) ||
      ((application.status === applicationConstants.STATUS_ACCEPT_WITH_CHANGES ||
        application.status === applicationConstants.STATUS_ACCEPT) &&
        user.role_id === roleConstants.ROLE_ADMIN) ? (
      <Button className={cls} onClick={handleDecline(application.id)}>
        Отклонить
      </Button>
    ) : (
      ''
    );
  }
}

const mapStateToProps = state => {
  const { adminApplications } = state;

  return {
    adminApplications
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { dispatch } = dispatchProps;

  const handleDecline = id => {
    return e => dispatch(applicationActions.openDeclineModal(id));
  };

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,

    handleDecline
  };
};

const connectedApplicationDeclineButton = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ApplicationDeclineButton);
export { connectedApplicationDeclineButton as ApplicationDeclineButton };
